const permitTypes = {
  subheadings: {
    details: 'permit details',
    notifications: 'notification settings',
    website: 'permit registration website settings',
    guest_permits: 'guest permits',
    field_config: 'permit registration form fields',
  },
  helpers: {
    quantity_of_spots: 'maximum number of active permits',
    default_term:
      'permits of this type will be issued for this duration by default',
    needs_approval:
      'permits of this type must be approved by a property manager after registration',
    renewal_reminder:
      'send a renewal link to the permit holder before their permit expires',
    expiration_notification:
      'send an email to the permit holder when their permit expires',
    revocation_notification:
      'send an email to the permit holder if their permit is revoked',
    rate_limit:
      'limit the number of permits of this type that can be issued within a given time period',
    self_service: 'enable the public permit registration website for this property',
    invite_only:
      'an invitation is required to access the permit registration website',
    mobile_features: 'some features on this page are not available on mobile',
    guest_permits:
      'enable permit holders to request guest permits through the permit registration website',
    guest_permits_term: 'how long the guest permit is valid for',
    guest_permits_rate: 'how many guest permits can be issued per unit of time',
    field_config:
      'In addition to Full Name, Email, and Plate Number/State, choose what fields appear on the permit registration form',
    payments_disabled: 'Connect your TowPay account to enable payments.',
  },
  labels: {
    guest_permit_rate: 'Guest Permit Allowance',
    permits_per: 'permits per',
    every: 'every',
    website: 'website',
    self_service_only: '(Self Service Only)',
    free: 'Free',
    price_per_unit: 'Price',
    default_term: 'Default Term',
    needs_approval: 'Approval Required',
    unlimited: 'Unlimited',
  },
  toasts: {
    no_options:
      'No permit types found. Please create a permit type before importing permits.',
  },
};

export default permitTypes;
